/* global window */
import { supportLocalStorage } from 'Helpers/localStorage';
import cookieManagerHelper from 'Helpers/cookies';
import {
    KYC_REPLY_RESTRICTION_METADATA,
    KYC_REPLY_RESTRICTION_SELLER_METADATA,
    KYC_EXPERIMENT,
    KYC_EXPERIMENT_SELLER,
    KYC_REPLY_COUNT
} from 'ragnarok-web/dist/Constants/constants';

const setReplyRestrictionData = data => {
    if (supportLocalStorage()) {
        window.localStorage.setItem('reply_restriction_metadata', JSON.stringify(data));
    }
};

const readReplyRestrictionData = () => {
    if (supportLocalStorage()) {
        const replyRestriction = window.localStorage.getItem('reply_restriction_metadata');

        return replyRestriction ? JSON.parse(replyRestriction) : null;
    }
    return {};
};

const setKYCReplyRestrictionData = data => {
    if (supportLocalStorage()) {
        window.localStorage.setItem(KYC_REPLY_RESTRICTION_METADATA, JSON.stringify(data));
    }
};

const setKYCReplyRestrictionSellerData = data => {
    if (supportLocalStorage()) {
        window.localStorage.setItem(KYC_REPLY_RESTRICTION_SELLER_METADATA, JSON.stringify(data));
    }
};

const getKYCReplyFeatureMetaData = (isSeller = false) => {
    try {
        if (supportLocalStorage()) {
            const kycMetaDta = window.localStorage.getItem(isSeller ? KYC_REPLY_RESTRICTION_SELLER_METADATA : KYC_REPLY_RESTRICTION_METADATA);

            return kycMetaDta ? JSON.parse(kycMetaDta) : {};
        }
    }
    catch (e) {
        return {};
    }

    return {};
};

const getKYCReplyCount = () => {
    const kycReplyCount = cookieManagerHelper.readCookie(KYC_REPLY_COUNT);

    return kycReplyCount;
};

const isUserKYCEnabled = (isSeller = false) => {
    try {
        if (supportLocalStorage()) {
            const kycMetaDta = window.localStorage.getItem(isSeller ? KYC_EXPERIMENT_SELLER : KYC_EXPERIMENT);

            return kycMetaDta ? JSON.parse(kycMetaDta) : false;
        }
    }
    catch (e) {
        return false;
    }
    return false;
};

const getExpiration = (expirationInDays = 1) => {
    const minusSeconds = 1000;
    const tomorrow = new Date();

    tomorrow.setDate(tomorrow.getDate() + expirationInDays);
    const expiration = new Date(tomorrow.setHours(0, 0, 0, 0) - minusSeconds);

    return expiration;
};

const setKycReplyCount = (kycReplyCount, days) => {
    const kycExpiration = getExpiration(days);

    cookieManagerHelper.createCookie(KYC_REPLY_COUNT, kycReplyCount, undefined, undefined, kycExpiration);
};

const setAPICallDelay = (data = 0) => {
    if (supportLocalStorage()) {
        window.localStorage.setItem('kyc_api_call_delay', JSON.stringify(data));
    }
};

const getAPICallDelay = () => {
    try {
        if (supportLocalStorage()) {
            const kycMetaDta = window.localStorage.getItem('kyc_api_call_delay');

            return kycMetaDta ? Number(kycMetaDta) : 0;
        }
    }
    catch (e) {
        return 0;
    }
    return 0;
};

export {
    setReplyRestrictionData,
    readReplyRestrictionData,
    setKYCReplyRestrictionData,
    setKYCReplyRestrictionSellerData,
    getKYCReplyFeatureMetaData,
    getKYCReplyCount,
    isUserKYCEnabled,
    setKycReplyCount,
    setAPICallDelay,
    getAPICallDelay
};

